// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__4aLeL","container":"Modal_container__Q5Yuq","closeButton":"Modal_closeButton__RazLQ"};